<template>
  <div id="Security">
    <div class="header-security">SECURITY</div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form-input">
        <input
          type="password"
          class="input"
          placeholder="Password"
          v-model="password"
        />
      </div>

      <div class="button">
        <input
          type="submit"
          class="btn btn-primary btn-save mr-15"
          value="Change"
        />
        <input
          type="reset"
          class="btn btn-default btn-reset"
          value="Cancel"
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
    };
  },
  methods: {
    rollback() {
      this.password = "";
    },
    onSubmit() {
      if (this.password) {
        this.$repo.user
          .changePassword(this.password)
          .then(() => {
            this.$toasted.show("Password has been changed successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right",
            });
          })
          .catch((err) => {
            console.log(err);

            this.$toasted.show("Sorry, Something went wrong. Please try again later.", {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#Security {
  .header-security {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .form {
    .form-input {
      margin-bottom: 8px;

      .input {
        font-size: 12px;
        padding: 12px;
        width: 360px;
      }
    }

    .button {
      input[type="submit"], 
      input[type="reset"] {
        width: 172px;
        height: 50px;
        color: #fff;
        border: 0;
        text-transform: uppercase;

        &:disabled,
        &.inactive {
          background-color: #b9b9b9;
        }
      }
    }

    .mr-15 {
      margin-right: 15px;
    }

    .mb-40 {
      margin-bottom: 40px;
    }

    .mb-30 {
      margin-bottom: 30px;
    }
  }
}
</style>
